export default __webpack_public_path__ + "static/media/fullstack.88e24c21.svg";